import api from 'Application/api/api';

const closeRfep = (signal, tenderId) =>
	api.post(`/tenders/close/${tenderId}`, {
		signal,
	});

export default closeRfep;
